export const einRegExp = /^\d{2}-?\d{7}$/;
export const optionalEinRegExp = /^$|^\d{2}-?\d{7}$/;
export const zipRegExp = /^\d{5}(-\d{4})?$/;
export const phoneRegExp = /^[2-9]\d{2}[-]?\d{3}[-]?\d{4}$/;
export const emailRegExp = /^(("[\p{L}\p{N}\p{M}_+\-\p{Z}]+")|([\p{L}\p{N}\p{M}_+-]+(?:\.[\p{L}\p{N}\p{M}_+-]+)*)|("[\p{L}\p{N}\p{M}_+\-\p{Z}]+")([\p{L}\p{N}\p{M}_+-]+(?:\.[\p{L}\p{N}\p{M}_+-]+)*))(@((?:[\p{L}\p{N}\p{M}_+-]+\.)*[\p{L}\p{N}\p{M}_][\p{L}\p{N}\p{M}_+-]{0,66})\.([a-z]{2,63}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/iu;
export const urlRegEx = /^https?:\/\/.+\..+$/;
export const fullNameRegExp = /^\s*\S+(\s+\S+)+\s*$/;

const strongPasswordRegExp = /^(?=.*[0-9])(?=.*[A-Z])(?=.{6,}).+$/;
export const isStrongPassword = (password: string): boolean =>
    strongPasswordRegExp.test(password);
